(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wl-why-bamboo-page"] && !Shopify.designMode) return;
  try {
    
function wlWhyReviewsbarInit(root) {
  root.querySelectorAll('.wl-why-reviewsbar').forEach(function (bar) {
    if (bar.dataset.wlInit === 'true') return;
    bar.dataset.wlInit = 'true';
    var track = bar.querySelector('.wl-why-reviewsbar__track');
    var slides = bar.querySelectorAll('.wl-why-reviewsbar__slide');
    var prev = bar.querySelector('.wl-why-reviewsbar__arrow--prev');
    var next = bar.querySelector('.wl-why-reviewsbar__arrow--next');
    if (!track || slides.length <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }
    var index = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = bar.dataset.autoplay === 'true' && !reduceMotion;
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    var timer = null;
    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    next.addEventListener('click', function () { go(index + 1); start(); });
    prev.addEventListener('click', function () { go(index - 1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('touchstart', stop, { passive: true });
    bar.addEventListener('touchend', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', function (evt) {
      if (!bar.contains(evt.relatedTarget)) start();
    });
    go(0);
    start();
  });
}
wlWhyReviewsbarInit(document);
document.addEventListener('shopify:section:load', function (evt) {
  wlWhyReviewsbarInit(evt.target);
});

  } catch(e) { console.error(e); }
})();
})();
